import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import Menu from "./Menu";
import Booking from "./Booking";
import Slider from "./Slider";
import Dataentry from "./Dataentry";
import SiteFooter from "./SiteFooter";
import axios from 'axios';
import Live from './Live';
import Popup from './Popup';
import Rightside from './Rightside';
import LatestNews from "./LatestNews";
import Rolling from './Rolling';
import "./rolling.css";
import Video from "./Video";
import DietyFront from "./DietyFront";

import NoticeSection from "./NoticeSection";
import { FaBullhorn, FaFileAlt } from "react-icons/fa";

import { useTranslation } from "react-i18next";
import LanguageSelector from './LanguageSelector';


// const API_BASE = "http://localhost/myapp/api/uploads";

const API_BASE = "https://spst.in/myapp/api/uploads";

function Home() {

	const [uploads, setUploads] = useState([]);
	const [editId, setEditId] = useState(null);
	const [editName, setEditName] = useState('');

	useEffect(() => {
		fetchUploads();
	}, []);

	const fetchUploads = async () => {
		const res = await axios.get(`${API_BASE}/get.php`);
		setUploads(res.data);
	};

	const handleDelete = async (id) => {
		if (!window.confirm("Delete this record?")) return;
		await axios.post(`${API_BASE}/delete.php`, { id });
		fetchUploads();
	};

	const startEdit = (item) => {
		setEditId(item.id);
		setEditName(item.name);
	};

	const saveEdit = async () => {
		await axios.post(`${API_BASE}/update.php`, { id: editId, name: editName });
		setEditId(null);
		fetchUploads();
	};

	const { t } = useTranslation();

	return (
		<div>


			{/* <Popup /> */}

			{/* <Slider /> */}
			<Video />
			<div className="row" style={{ marginTop: '-6px',marginBottom:'15px' }}>
				<div className="col-md-12">
					<Rolling />
				</div>
				{/* <div className="col-md-3">
					<div className="updating">
						<Link to="/News" className="imp" style={{float:'left',marginRight:'15px',paddingLeft:'20px',paddingRight:'20px'}} >
							<FaBullhorn className="btn-icon" />
							<span className="anews" style={{fontSize:'12pt'}}>News & Events</span>
						</Link>
						<Link to="/Tenders" className="imp" style={{float:'left',paddingLeft:'20px',paddingRight:'20px'}} >
							<FaFileAlt className="btn-icon" />
							<span className="anews" style={{fontSize:'12pt'}}>Tenders</span>
						</Link>
					</div>
				</div> */}
			</div>


			{/* <div className="container" style={{display:'flex',width:'100%',marginBottom:'25px'}}>
			<div className="col-md-2" style={{background:'orange',color:'maroon',display:'flex',alignItems:'center',justifyContent:'center',borderRadius:'0px 0px 15px 15px'}}>
				<h4 style={{fontWeight:'600',color:'maroon'}}>Latest Updates</h4>
			</div>
			<div className="col-md-10" style={{background:'maroon',padding:'5px',borderRadius:'0px 0px 15px 15px',display:'flex',alignItems:'middle'}}>
				<Marquee speed={50} gradient={false} pauseOnHover>
					<div class="news_post_title" style={{padding:'0px'}}><p style={{color:'white',fontSize:'12pt'}}>For enquiries and booking, Contact at +91 471 246 6830</p></div>
				</Marquee>
			</div>
	  </div> */}

	  <DietyFront />
			<div class="booking-container">

				{/* <!-- SINGLE DAY --> */}
				<div class="booking-box single">
					<div class="icon" style={{padding:'40px'}}>
						<img src="https://cdn-icons-png.flaticon.com/512/3652/3652191.png" alt="Single Day Pooja Booking" />
					</div>
					<h3 className="books-3-ways">{t("single_day")}</h3>
					<div class="infobar">
						<span></span>
					</div>
					<p style={{ fontFamily: 'manjari !' }}>{t("d_single_day")}</p>

					<div class="book-btn">
						<a href="https://booking.peralasserytemple.in/Default.aspx">
							Book Now
						</a>
					</div>

				</div>

				{/* <!-- MULTIPLE DAY --> */}
				<div class="booking-box multiple">
					<div class="icon" style={{padding:'40px'}}>
						<img src="https://cdn-icons-png.flaticon.com/512/3652/3652191.png" alt="Multi dy Pooja Booking" />
					</div>
					<h3 className="books-3-ways">{t("multi_day")}</h3>
					<div class="infobar">
						<span></span>
					</div>
					<p>{t("d_multi_day")}</p>

					<div class="book-btn">
						<a href="https://booking.peralasserytemple.in/multiple.aspx">
							Book Now
						</a>
					</div>

				</div>

				{/* <!-- E-KANIKKA --> */}
				<div class="booking-box ekanikka">
					<div class="icon" style={{padding:'40px'}}>
						<img src="https://static.thenounproject.com/png/772000-512.png?utm_source=chatgpt.com" alt="e-kanikka" />
					</div>
					<h3 className="books-3-ways">{t("offer")}</h3>

					<div class="infobar">
						<span></span>
					</div>
					<p>{t("dona")}</p>
					<div class="book-btn">
						<a href="https://booking.peralasserytemple.in/Donation.aspx">
							Offer Now
						</a>
					</div>

				</div>

			</div>

			<div className="container flower-section">

				{/* 🌸 Floating Flowers */}
				<div className="flowers">
					<span></span>
					<span></span>
					<span></span>
					<span></span>
					<span></span>

				</div>

				<div className="imageprominant" >
					<img src="/images/murugan-2.png" alt="murugan" className="murugan-img" />
				</div>

				<div className="frontbox" style={{ padding: '15px' }}>
					<p className="historyheadeg" style={{ textAlign: "center" }}>
						{t("temple_name")}
					</p>

					<p className="frame-1-p">{t("home_p")}</p>
				</div>
				<Rightside />

			</div>

			{/* <div className="row">
				<LatestNews />
			</div> */}

			<div className="row">

				<div className="col-12 col-md-12" style={{ marginBottom: '50px' }}>

					{/* <p className="about" >
						ത്രേതായുഗത്തിൽ വനവാസകാലത്ത് യാത്രാമദ്ധ്യേ ശ്രീ അയ്യപ്പ ക്ഷേത്രത്തിൽ ആഗതനായ ഭഗവാൻ ശ്രീരാമചന്ദ്രൻ ഇവിടെ സുബ്രഹ്മണ്യ സാന്നിദ്ധ്വം അനുഭവപ്പെട്ടതിനാൽ സുബ്രഹ്മണ്യ പ്രതിഷ്ഠ നടത്തുന്നതിനായി സന്തത സഹചാരിയായ ശ്രീ ഹനുമാൻ സ്വാമിയോടു സുബ്രഹ്മണവിഗ്രഹം കൊണ്ടുവരുവാൻ നിർദ്ദേശിക്കുകയും മുഹൂർത്ത സമയത്ത് വിഗ്രഹം എത്താതിരുന്നതിനാൽ മുഹൂർത്തം തെറ്റാതിരിക്കാൻ ശ്രീരാമൻ തന്റെ കൈയ്യിലെ പെരുവളയൂരിയെടുത്തു പ്രതിഷ്ഠിക്കുകയും പെരുവള പ്രതി ഷ്ഠിക്കപ്പെട്ട ക്ഷേത്രവും, പ്രദേശവും പെരുവളശ്ശേരി എന്നും, കാലാന്തരത്തിൽ പെരളശ്ശേരിയായി പ്രസിദ്ധി നേടുകയും ചെയ്തു.
പൗരാണികവും കേരളവാസ്തു ശിൽപ്പചാരുത വിളിച്ചോതുന്നതുമായ മനോഹരമായ തീർത്ഥക്കുളം ഭക്തജനങ്ങളെ ഹഠാദാകർഷിക്കുകയും ആയത് ക്ഷേത്രത്തിന്റെ മാത്രം പ്രത്യേകതയായി നിലനിൽക്കുകയും ചെയ്തു വരുന്നു. കേരളത്തിലെ നാഗാരാധന നടക്കുന്ന പ്രധാന ക്ഷേത്രങ്ങളിലൊന്നാണ് ശ്രീ പെരളശ്ശേരി ക്ഷേത്രം.
					</p> */}

					<div class="notice-container-" style={{ paddingTop:'100px', paddingBottom:'100px', marginBottom: '100px', marginTop: '10px', background: 'white',  border: 'none',background: "linear-gradient(135deg, #ffbf91, #ff4500, #ffbf76)", padding: '25px', backgroundSize: 'cover', backgroundPosition: 'left', backgroundAttachment: 'fixed' }}>
						<NoticeSection />
					</div>

					<div class="notice-container-" style={{ margin: '50px', marginTop: '100px' }}>

						<div class="notice-title">
							{t("ftn")}
						</div>

						<div class="notice-grid">

							{/* <!-- Card 1 --> */}
							<div class="notice-card">
								<img src="./images/slider-1.jpg" alt="image" style={{ width: '100%', marginBottom: '25px' }} />
								<h3 style={{ fontFamily: 'manjari', fontSize: '18pt' }}>{t("vm")}</h3>
								<ul style={{ listStyle: 'none' }}>
									<li>{t("dnk")}</li>
									<li>{t("dma")}</li>
								</ul>
							</div>

							{/* <!-- Card 2 --> */}
							<div class="notice-card">
								<img src="./images/slider-2.jpg" alt="image" style={{ width: '100%', marginBottom: '25px' }} />
								<h3 style={{ fontFamily: 'manjari', fontSize: '18pt' }}>{t("spd")}</h3>
								<ul>
									<li>{t("tskv")}</li>
									<li>{t("vsu")}</li>
									<li>{t("spdk")}</li>
								</ul>
							</div>

							{/* <!-- Card 3 --> */}
							<div class="notice-card">
								<img src="./images/slider-3.jpg" alt="image" style={{ width: '100%', marginBottom: '25px' }} />
								<h3 style={{ fontFamily: 'manjari', fontSize: '18pt' }}>{t("mvs")}</h3>
								<ul>
									<li>{t("avsu")}</li>
								</ul>
							</div>

						</div>

					</div>
					{/* <div className="container" style={{ padding: '20px', background: 'white' }}>
						<h3 style={{ textAlign: 'center',fontFamily:'manjari' }}>{t("dona")}</h3>
						
					</div> */}


				</div>
				{/* <div className="col-12 col-md-4" style={{ backgroundImage: 'url(./images/slider-1.jpg)', padding: '25px', backgroundSize: 'cover', backgroundPosition: 'left', backgroundAttachment: 'fixed' }}>
					<div style={{ border: '1px solid silver', borderRadius: '10px', boxShadow: '0px 0px 10px silver inset', padding: '25px', paddingBottom: '20px', background: 'white' }}>
						<Rightside />

					</div>

				</div> */}
			</div>
		</div>

	);
}

export default Home;